import React, {Component} from 'react';
import ConfirmationMessage from "../../../components/confirmationMessage"
import MaintenanceScheduleView from "./MaintenanceScheduleView";
import {Button} from "primereact/button";
import {MaintenanceScheduleService} from "../../../service/maintenance/schedule/MaintenanceScheduleService";
import {MAINTENANCE_SCHEDULE_ROUTE, MODIFY_INSTITUTION_SCHEDULE_ROUTE} from "../../../utils/constants/RoutesConstants"
import {Growl} from "primereact/growl";
import ContextMenu from "../../../components/contextMenu";

export default class MaintenanceScheduleContainer extends Component {

    /**
     * Constructor de la clase MaintenanceAccountsContainer
     * en este se inicializan los valores iniciales de la clase.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.maintenanceScheduleService = new MaintenanceScheduleService();

        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.getDataSchedule = this.getDataSchedule.bind(this);
        this.getDataControlPanelSchedule = this.getDataControlPanelSchedule.bind(this);
        this.getDataInstitutionsSchedule = this.getDataInstitutionsSchedule.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);
        this.saveAllSchedule = this.saveAllSchedule.bind(this);
        this.setErrors = this.setErrors.bind(this);

        this.state = {
            isLoading: true,
            anchorEl: null,
            activeIndex: this.props.location.activeIndex ?
                this.props.location.activeIndex : 0,
            dataSchedule: this.getDataSchedule(),
            dataControlPanelSchedule: this.getDataControlPanelSchedule(),
            dataInstitutionsSchedule: this.getDataInstitutionsSchedule(),
            selectedInstitution: '',
            items: [
                {
                    label: 'Sistema',
                },
                {
                    label: 'Instituciones',
                },
            ],
        };

        this.maintenanceScheduleActionTemplate = this.maintenanceScheduleActionTemplate.bind(this);
        this.handleSelectInstitution = this.handleSelectInstitution.bind(this);
        this.openConfirmationDelete = this.openConfirmationDelete.bind(this);
        this.deleteInstitutionSchedule = this.deleteInstitutionSchedule.bind(this);
        this.redirectModifyInstitutionSchedule = this.redirectModifyInstitutionSchedule.bind(this);
        this.validSchedules = this.validSchedules.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    /**
     * Función que genera un arreglo booleano para identificar si existe algún campo
     * que no haya sido llenado o tenga algún valor no válido.
     * @returns {[]} Arreglo booleano del tamaño del número de campos
     */
    setErrors() {
        let dataScheduleAux = this.state.dataSchedule ? this.state.dataSchedule : {};
        let errors = [];
        for (let key in dataScheduleAux) {
            if (key.length > 7) {
                errors[key] = dataScheduleAux[key] !== '';
            }
        }
        return errors;
    }

    /**
     * Función que obtiene los datos para inicializar la pantalla de mantienimiento de horarios
     * trae los datos de Horario de operación y Horario de formalización de préstamos.
     * @returns {Promise<void | unknown> | Promise<void> | Promise<void>}
     */
    getDataSchedule() {
        this.loading();
        return this.maintenanceScheduleService.getSchedule()
            .then(dataSchedule =>
                this.setState({
                    dataScheduleDefault: this.getTimeObjectDefault(dataSchedule),
                    dataSchedule: this.getTimeObject(dataSchedule),
                    errors: this.setErrors(),
                    isLoading: false,
                }));
    }

    /**
     * Función que a partir de un string, obtiene una variable tipo Date.
     * @param dateStr String del que se obtiene la hora
     * @returns {Date} Variable tipo Date con los datos de la hora.
     */
    getDateFromStr(dateStr) {
        let [hrs, min] = dateStr.split(":");
        let dateAux = new Date();
        dateAux.setHours(hrs);
        dateAux.setMinutes(min);
        dateAux.setSeconds(0);
        return dateAux;
    }

    /**
     * Función que construye un objeto con los datos de los horarios por default.
     * @param dataSchedule Objeto con horarios default
     */
    getTimeObjectDefault(dataSchedule) {
        let timeObjectDefaultAux = {};
        timeObjectDefaultAux['startOperation'] = this.getDateFromStr(dataSchedule[0].horaIDefault);
        timeObjectDefaultAux['endOperation'] = this.getDateFromStr(dataSchedule[0].horaFDefault);
        timeObjectDefaultAux['startFormalization'] = this.getDateFromStr(dataSchedule[1].horaIDefault);
        timeObjectDefaultAux['endFormalization'] = this.getDateFromStr(dataSchedule[1].horaFDefault);
        return timeObjectDefaultAux;
    }

    /**
     * Función que construye un objeto con los datos de los horarios de operación
     * y formalización.
     * @param dataSchedule Datos obtenidos de la petición que serán transformados
     *      en el objeto.
     * @returns {*} Objeto con los datos de operación y formalización.
     */
    getTimeObject(dataSchedule) {
        let timeObjectAux = this.state.dataSchedule ? this.state.dataSchedule : {};
        timeObjectAux['startOperation'] = this.getDateFromStr(dataSchedule[0].horaInicial);
        timeObjectAux['endOperation'] = this.getDateFromStr(dataSchedule[0].horaFinal);
        timeObjectAux['startFormalization'] = this.getDateFromStr(dataSchedule[1].horaInicial);
        timeObjectAux['endFormalization'] = this.getDateFromStr(dataSchedule[1].horaFinal);
        return timeObjectAux;
    }

    /**
     * Función que obtiene los datos para inicializar la pantalla de mantienimiento de horarios
     * trae los datos de Horario de Tablero de Control.
     * @returns {Promise<void | unknown> | Promise<void> | Promise<void>}
     */
    getDataControlPanelSchedule() {
        this.loading();
        return this.maintenanceScheduleService.getControlPanelSchedule()
            .then(dataControlPanelSchedule =>
                this.setState({
                    dataSchedule: this.getTimeControlPanel(dataControlPanelSchedule),
                    errors: this.setErrors(),
                    isLoading: false,
                }));
    }

    /**
     * Función que construye un objeto con los datos del horario del Tablero de control
     * @param dataControlPanelSchedule Datos obtenidos de la petición que serán transformados
     *      en el objeto.
     * @returns {*} Objeto con los datos de operación y formalización.
     */
    getTimeControlPanel(dataControlPanelSchedule) {
        let timeObjectAux = this.state.dataSchedule ? this.state.dataSchedule : {};
        timeObjectAux['timeControlPanelPtm'] = this.getDateFromStr(
            dataControlPanelSchedule[0].hora + ":" + dataControlPanelSchedule[0].minuto);
        timeObjectAux['timeControlPanelPtt'] = this.getDateFromStr(
            dataControlPanelSchedule[1].hora + ":" + dataControlPanelSchedule[1].minuto);
        timeObjectAux['timeControlPanelFid'] = this.getDateFromStr(
            dataControlPanelSchedule[2].hora + ":" + dataControlPanelSchedule[2].minuto);
        timeObjectAux['timeControlPanelGSS'] = this.getDateFromStr(
            dataControlPanelSchedule[3].hora + ":" + dataControlPanelSchedule[3].minuto);
        timeObjectAux['timeControlPanelLiq'] = this.getDateFromStr(
            dataControlPanelSchedule[4].hora + ":" + dataControlPanelSchedule[4].minuto);
        timeObjectAux['timeControlPanelIndeval'] = this.getDateFromStr(
            dataControlPanelSchedule[5].hora + ":" + dataControlPanelSchedule[5].minuto);
        return timeObjectAux;
    }

    /**
     * Función que obtiene los datos para inicializar la pantalla de mantienimiento de horarios
     * trae los datos los horarios por instituciones.
     * @returns {Promise<void | unknown> | Promise<void> | Promise<void>}
     */
    getDataInstitutionsSchedule() {
        this.loading();
        return this.maintenanceScheduleService.getInstitutionsSchedule()
            .then(dataInstitutionsSchedule =>
                this.setState({
                    dataInstitutionsSchedule: dataInstitutionsSchedule,
                    isLoading: false,
                })
            );
    }

    /**
     * Función que coloca los valores default en el objeto que se manda a la vista.
     */
    setDefaultValues() {
        this.loading();
        let dataScheduleAux = this.state.dataSchedule;
        dataScheduleAux['startOperation'] = this.state.dataScheduleDefault['startOperation'];
        dataScheduleAux['endOperation'] = this.state.dataScheduleDefault['endOperation'];
        dataScheduleAux['startFormalization'] = this.state.dataScheduleDefault['startFormalization'];
        dataScheduleAux['endFormalization'] = this.state.dataScheduleDefault['endFormalization'];
        this.setState({
            dataSchedule: dataScheduleAux,
            isLoading: false,
        });
    }

    /**
     * Función que hace una petición al back para guardar todos los datos de mantenimiento
     * de horarios en su pestaña de sistema. (Horario de operación, de formalización y
     * del tablero de control)
     */
    saveAllSchedule() {
        let dataScheduleAux = this.state.dataSchedule;
        let errorsAux = this.state.errors;
        let completeData = true;

        for (let key in errorsAux) {
            if (!errorsAux[key]) {
                completeData = false;
            }
        }
        if (!completeData) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Llenar correctamente los campos requeridos'
            });
        } else if (this.validSchedules()) {
            this.loading();
            let objectSchedule = {
                startOperationHr: dataScheduleAux['startOperation'].getHours(),
                startOperationMin: dataScheduleAux['startOperation'].getMinutes(),
                endOperationHr: dataScheduleAux['endOperation'].getHours(),
                endOperationMin: dataScheduleAux['endOperation'].getMinutes(),
                startFormalizationHr: dataScheduleAux['startFormalization'].getHours(),
                startFormalizationMin: dataScheduleAux['startFormalization'].getMinutes(),
                endFormalizationHr: dataScheduleAux['endFormalization'].getHours(),
                endFormalizationMin: dataScheduleAux['endFormalization'].getMinutes(),
                timeControlPanelPtmHr: dataScheduleAux['timeControlPanelPtm'].getHours(),
                timeControlPanelPtmMin: dataScheduleAux['timeControlPanelPtm'].getMinutes(),
                timeControlPanelPttHr: dataScheduleAux['timeControlPanelPtt'].getHours(),
                timeControlPanelPttMin: dataScheduleAux['timeControlPanelPtt'].getMinutes(),
                timeControlPanelFidHr: dataScheduleAux['timeControlPanelFid'].getHours(),
                timeControlPanelFidMin: dataScheduleAux['timeControlPanelFid'].getMinutes(),
                timeControlPanelLiqHr: dataScheduleAux['timeControlPanelLiq'].getHours(),
                timeControlPanelLiqMin: dataScheduleAux['timeControlPanelLiq'].getMinutes(),
                timeControlPanelIndevalHr: dataScheduleAux['timeControlPanelIndeval'].getHours(),
                timeControlPanelIndevalMin: dataScheduleAux['timeControlPanelIndeval'].getMinutes(),
                timeControlPanelGSSHr: dataScheduleAux['timeControlPanelGSS'].getHours(),
                timeControlPanelGSSMin: dataScheduleAux['timeControlPanelGSS'].getMinutes(),
            };
            this.maintenanceScheduleService.saveAllSchedule(objectSchedule)
                .then(resp => {
                    if (resp.message === "Success") {
                        this.growl.show({
                            severity: 'success', summary: 'Atención.',
                            detail: 'Los horarios se actualizaron correctamente.'
                        });
                    } else if (resp.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Atención.',
                            detail: resp.error
                        });
                    }
                    this.setState({isLoading: false,})
                });
        }

    }

    validSchedules() {
        let dataScheduleAux = this.state.dataSchedule;
        let isValid = false;

        if (this.isValidSchedule(dataScheduleAux.startOperation, dataScheduleAux.endOperation)) {
            if (this.isValidSchedule(dataScheduleAux.startFormalization, dataScheduleAux.endFormalization)) {
                isValid = true;
            } else {
                this.growl.show({
                    severity: 'info', summary: 'Error.',
                    detail: 'Favor de validar el horario de formalización de préstamos'
                });
            }
        } else {
            this.growl.show({
                severity: 'info', summary: 'Error.',
                detail: 'Favor de validar el horario de operación'
            });
        }
        return isValid
    }

    isValidSchedule(start, end) {
        let isValid = false;
        if (start.getHours() < end.getHours()) {
            isValid = true;
        } else if (start.getHours() === end.getHours()) {
            isValid = start.getMinutes() < end.getMinutes();
        }
        return isValid;
    }

    /**
     * Función que guarda la opción de context menu que fue seleccionada
     * @param event
     */
    handleClick = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    /**
     * Función que guarda el cambio de tab en la vista, entre Sistema e instituciones.
     * @param event
     */
    handleTabChange = event => {
        this.setState({activeIndex: event.index})
    }

    /**
     * Función que maneja el cambio de horario en el componente
     * time.
     * @param name Nombre del componente modificado.
     * @param date Valor introducido en el componente.
     */
    handleTimeChange(name, date) {
        let timeObjectAux = this.state.dataSchedule;
        let errorsAux = this.state.errors;
        timeObjectAux[name] = date;
        errorsAux[name] = (!((date === null) || (isNaN(date))));
        this.setState({
            dataSchedule: timeObjectAux,
            errors: errorsAux,
        })
    }

    /**
     * Función que cierra el context menu cuando se seleccionó alguna
     * de las opciones desplegadas
     */
    handleClose = () => {
        this.setState({anchorEl: null});
    }

    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    maintenanceScheduleActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar", action: () => (this.redirectModifyInstitutionSchedule(""))},
            {label: "Eliminar", action: this.openConfirmationDelete}
        ];

        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    /**
     * Función que abre el mensaje de confirmación para borrar un registro de la tabla.
     * Guarda el elemento a eliminar en una variable del estado.
     */
    openConfirmationDelete() {
        if (this.state.selectedInstitution) {
            this.setState({deleteInstitutionValue: this.state.selectedInstitution.idInstitucion})
            this.handleClose();
            if (this.confirmationRef) {
                this.confirmationRef.openConfirmationMessage()
            }
        }
    }

    /**
     * Función que redirecciona a la pantalla de editar o agregar nuevo horario por institución
     */
    redirectModifyInstitutionSchedule(action) {
        let institutionAux = this.state.selectedInstitution ?
            this.state.selectedInstitution : {};
        this.props.history.push({
            pathname: MODIFY_INSTITUTION_SCHEDULE_ROUTE,
            state: {
                returnPath: MAINTENANCE_SCHEDULE_ROUTE,
                newInstitution: action === "new",
                dataInstitution: institutionAux,
            },
        });
    }

    /**
     * Función que maneja el cambio en el elemento seleccionado en la tabla.
     * Para la pestaña instituciones.
     * @param event Contiene la información del objeto a eliminar
     */
    handleSelectInstitution = (event) => {
        this.setState({
            selectedInstitution: event.value,
        });
    };

    /**
     * Función que consume el MaintenanceScheduleService y elimina el
     * elemento seleccionado.
     */
    deleteInstitutionSchedule() {
        this.loading();
        let idInstitution = this.state.deleteInstitutionValue;
        this.maintenanceScheduleService.deleteInstitutionSchedule(idInstitution)
            .then(resp => {
                let message = resp.message;
                let error = resp.error;
                if (message === 'Success') {
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'El registro se ha eliminado con éxito.'
                    });
                } else if (error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: error});
                }
                this.setState({
                    dataInstitutionsSchedule: this.getDataInstitutionsSchedule(),
                    isLoading: false,
                })
            });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Está seguro que desea eliminar el horario seleccionado?"
                                            action={this.deleteInstitutionSchedule}/>;
        let systemButtons =
            <div style={{textAlign: 'right'}}>
                <Button type="button" iconPos="left" label="Valores por defecto"
                        style={{marginRight: '.5em'}}
                        className="p-button-secondary"
                        onClick={this.setDefaultValues}
                />
                <Button type="button" iconPos="left" label="Guardar"
                        style={{marginRight: '.5em'}}
                        onClick={this.saveAllSchedule}
                />
            </div>;

        const {isLoading, activeIndex, dataSchedule, dataInstitutionsSchedule, items} = this.state;
        return (
            <MaintenanceScheduleView
                isLoading={isLoading}
                activeIndex={activeIndex}
                systemButtons={systemButtons}
                dataSchedule={dataSchedule}
                dataInstitutionsSchedule={dataInstitutionsSchedule}
                messagesGrowl={messagesGrowl}
                items={items}
                maintenanceScheduleActionTemplate={this.maintenanceScheduleActionTemplate}
                handleSelectInstitution={this.handleSelectInstitution}
                confirmationMsg={this.confMsg}
                redirectModifyInstitutionSchedule={this.redirectModifyInstitutionSchedule}
                handleTabChange={this.handleTabChange}
                handleTimeChange={this.handleTimeChange}
            />
        );
    }
}
